import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** clsx + tailwind-merge — the one class combinator for the shared slideshow UI. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
